<template>
<cc-container class="policy-content-detail">
    <cc-header-nav title="详情"></cc-header-nav>
    <cc-main style="background-color:#F2F2F2" class="policy-content-page">
    <div class="policy-detail">
      <div class="policy-content" >
        <div :class="{policy_content_text:isshow}" v-html="policy" style="padding:.1rem"></div>
      </div>
    </div>
    </cc-main>
</cc-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ListMixin from '../../mixins/list.js'
export default {
  name: 'policy-content',
  mixins: [ListMixin],
  data () {
    return {
      policy: '',
      policy_id: '',
      loading: false,
      finished: false,
      isshow: false
    }
  },
  computed: {
    ...mapGetters(['getloadPolicyContent'])
  },
  async created () {
    this.mRequest()
    this.policy_id = this.$route.params
    await this.LOAD_POLICY_CONTENT(this.policy_id)
    if (this.getloadPolicyContent.status === 0) {
      this.policy = this.getloadPolicyContent.data.content
      this.isshow = true
    }
    this.mSuccess()
  },
  methods: {
    ...mapActions(['LOAD_POLICY_CONTENT'])
  }
}
</script>

<style lang="scss" scoped>
.policy-content-detail{
  .policy-detail .pre{
    font-size: 30px;
    color: red;
    float: left;
  }

}
.policy-content-page{
  margin-top:0;
}
.policy_content_text{
   background-color: #fff;
   box-sizing: border-box;
   padding: 10px;
}
.policy-content {
  /deep/{
    h5{
     text-align: left!important;
     font-size: 20px !important;
     font-weight: 400 !important;
     color: #333 !important;
     .pre{
          color: #666666;
          font-size: 14px !important;
          line-height: 35px;
          &:nth-of-type(1),&:nth-of-type(2){
            height: 0;
          }
      }
    }
    .MsoNormal{
      font-size: 14px;
      line-height: 35px;
      span{
       font-size: 20px !important;
       strong{
         font-weight: 400 !important;
         color: #333 !important;
       }
      }
      &:last-of-type{
        span{
          color: #666666;
          font-size: 14px !important;
          line-height: 35px !important;
        }
      }
    }
    h4{
      font-size: 16px;
    }
    .p{
      color: #666666;
      font-size: 14px;
      line-height: 35px;
    }
  }
}

</style>
